module.exports = __webpack_public_path__ + "assets/img/redpacket-line-icon1.bbc99c7f.png";